module.exports = __webpack_public_path__ + "img/store_person_icon_blue.db60d8b4.svg";